const NB_MONTH_ABBREVIATIONS = ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des'];

/**
 * Formats a "YYYY-MM" string as an abbreviated Norwegian month and year, e.g. "2026-05" -> "Mai 2026".
 * Returns the input unchanged if it is not a recognisable year-month value.
 */
export function formatYearMonth(yearMonth: string): string {
    const [year, month] = yearMonth.split('-').map(Number);
    const name = NB_MONTH_ABBREVIATIONS[month - 1];
    if (!year || !name) return yearMonth;
    return `${name} ${year}`;
}
